import { render } from "./serviceOpen.vue?vue&type=template&id=57685121"
import script from "./serviceOpen.vue?vue&type=script&lang=js"
export * from "./serviceOpen.vue?vue&type=script&lang=js"

import "./serviceOpen.vue?vue&type=style&index=0&id=57685121&lang=css"

import exportComponent from "D:\\AllProject\\h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__